const INDIAN_STATES = [
  'Telangana',
  'Andaman & Nicobar Island',
  'Andhra Pradesh',
  'Arunanchal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Daman & Diu',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jammu & Kashmir',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Lakshadweep',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Chandigarh',
  'Puducherry',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Odisha',
  'Dadara & Nagar Havelli',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'NCT of Delhi'
]

const SERVER_URLS = {
  BACKEND_SERVER: process.env.REACT_APP_API_URL,
  BHUMEET_TELECALLER_LOCAL_SERVICE: 'http://localhost:3005',
  TELECALLERAUTHCODE: process.env.TELECALLERAUTHCODE
};
const PRICE_BY_TYPES = {
  TANK: "tank",
  ACRE: "acre"
}
const PRICE_BY = Object.values(PRICE_BY_TYPES)
const MAP_URLS = {
  ROAD: 'https://mt0.google.com/vt/lyrs=h&hl=en&x={x}&y={y}&z={z}',
  ROAD_MAP: 'https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
  TERRAIN: 'https://mt0.google.com/vt/lyrs=p&hl=en&x={x}&y={y}&z={z}',
  ALTER_ROAD: 'https://mt0.google.com/vt/lyrs=r&hl=en&x={x}&y={y}&z={z}',
  SATELITE: 'https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}',
  TERREN_ONLY: 'https://mt0.google.com/vt/lyrs=t&hl=en&x={x}&y={y}&z={z}',
  HYBRID: 'https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}',
}
const LIST_VIEW_TYPES = {
  DROPDOWN: "DROPDOWN",
};
const GLOBAL_STYLES = {
  ERROR: "#ff6464",
  ACTIVE: "#39A506",
  UPGRADE:"#4BAE4F",
  INACTIVE_GREY_COLOR: "#848484",
  LOW_INACTIVE_GREY_COLOR: "#f3f3f3",
  FONT_COLOR_SUB: "#848484",
  FONT_COLOR_HEADER: "#0F5EFF",
  BG_INACTIVE: "white",
  BG_ACTIVE: "#0F5EFF",
  FONT_SIZE_REGULAR: "11px",
  FONT_SIZE_MEDIUM: "13px",
  FONT_SIZE_SMALL: "10px",
  FONT_SIZE_BIG_HEADER: "19px",
  FONT_SIZE_MEDIUM_HEADER: "18px",
  FONT_SIZE_SMALL_HEADER: "16px",
  BORDER_COLOR: "#D9D9D9",
  BOX_SHADOW: "rgba(98, 115, 43, 0.1) 0px 0px 8px 2px",
  STATUS: {
    BACKGROUND: {
      COMPLETED: "rgba(0, 166, 136, 1)",
      PLACED: "rgba(255, 145, 15, 0.2) ",
      INPROGRESS: "rgba(178, 160, 0, 0.2)",
      CANCELLED: "rgba(219, 0, 0, 0.2)",
      ACCEPTED: "rgba(15, 94, 255, 0.2)",
      PAID: "rgba(0, 135, 13, 0.2)",
      RESCHEDULED: "rgb(0, 0, 128)",
      HOLD: "#8e9aaf",
      OUT_FOR_SERVICE: "rgb(213, 203, 236)",
    },
    TEXT: {
      COMPLETED: "#00A688",
      PLACED: "#FF910F",
      INPROGRESS: "#B2A000",
      CANCELLED: "#DB0000",
      ACCEPTED: "#0F5EFF",
      PAID: "#026B0C",
      HOLD: "#2BD2DD",
      RESCHEDULED: "#E27444",
      OUT_FOR_SERVICE: "#12D58F",
      NOT_AVAILABLE: "#848484",
      MISSED: "#3B3B3B",
      REJECTED: "#1E1E1E"
    }
  }
};

const IDENTITY_CARD_TYPES = {
  AADHAR_CARD: "aadhar_card",
  PAN_CARD: "pan_card",
};
const AEROMEGH_SERVICES = {
  SPRAYING: "Spraying service",
  SURVEY: "Survey service",
  TRAINING: "Training service",
  INSURANCE: "Insurance service",
};

const REWARD_ORDERS_STATUSES = {
  PLACED: "Placed",
  CANCELLED: "Cancelled",
  INPROCESS: "Inprocess",
  BACKORDER: "Back Ordered",
  COMPLETED: "Completed",
}

const QUEUE_ORDER_STATUS = {
  NOACTION: 'No_Action',
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  OTHERDSP: 'Assign_to_Other',
  EXPIRED: 'Expired',
  CANCELLEDBYDSP: 'Cancelled_by_Dsp',
  CANCELLEDBYFARMER: 'Cancelled_by_Farmer',
  CANCELLEDBYOPRATIONS: 'Cancelled_by_Operations',
  MISSEDBYFARMER: 'Missed_by_Farmer',
}

const STATUS = {
  PLACED: "Placed",
  ACCEPTED: "Accepted",
  RESCHEDULED: "Rescheduled",
  OUT_FOR_SERVICE: "Out for Service",
  HOLD: "On Hold",
  INPROGRESS: "InProgress",
  COMPLETED: "Completed",
  PAID: "Paid",
  CANCELLED: "Cancelled",
}

const BES_INCENTIVE_STATUS = {
  PENDING: "Pending",
  SUBMITTED: "Submitted",
  SETTELED: "Settled",
  DISPUTED: "Disputed"
}


const allIssueTypes = [
  { label: 'Cancellation Dispute', value: 'Cancellation Dispute' },
  { label: 'Farmer Refund Request', value: 'Farmer Refund Request' },
  { label: 'Fraud - BES', value: 'Fraud - BES' },
  { label: 'Fraud - BhuMeet Mitra', value: 'Fraud - BhuMeet Mitra' },
  { label: 'Other', value: 'Other' },
  { label: 'Poor Spraying Quality', value: 'Poor Spraying Quality' },
  {
    label: 'Service Delay – Opted for Another Provider',
    value: 'Service Delay – Opted for Another Provider'
  },
  { label: 'Status Mismatch', value: 'Status Mismatch' },
  { label: 'System Area Mismatch', value: 'System Area Mismatch' },
  {
    label: 'System Payment Mismatch',
    value: 'System Payment Mismatch'
  }
];

const STATUS_MESSAGES = {
  PLACED: "Service request has been placed.",
  ACCEPTED: "Service request has been accepted.",
  RESCHEDULED: "Service request has been rescheduled.",
  OUT_FOR_SERVICE: "Service request is out for service.",
  INPROGRESS: "Service request is in progress.",
  COMPLETED: "Service has been completed.",
  PAID: "Total amount has been received.",
  HOLD: "Service request is on hold",
  CANCELLED: "Service request has been cancelled."
}

const DRONE_CAPACITIES = ["5 ltr", "6 ltr", "8 ltr", "10 ltr", "16 ltr", "20 ltr"];
const DRONE_UIN = [
  "1fe490ad-4f0a-46c6-bf73-d6f86f89db9e",
  "b59494ab-666f-4e50-ae53-578487f0ce94",
  "ae7025f7-c421-40b3-b2fa-fcf61ed795c2",
  "73921c44-be56-406f-8b18-320462b7df71",

]

const DISCOUNT_TYPES = {
  DSP_REQUEST_DISCOUNT: "dsp_request_discount"
}

const DRONE_TYPES = ["eVTOLS", "Hexacopter", "Quadcopters"];
const DRONE_NAMES = {
  eVTOLS: "eVTOLS",
  Hexacopter: "Hexacopter",
  Quadcopters: "Quadcopters"
}
const SERVICE_TYPES = ["Spraying", "Survey"]
const LIMITS = {
  NAME: 50,
  PASSWORD: 14,
  PHONE_NUMBER: 10,
  ADDRESS: 200,
  RATE_PER_ACRE: 1000000,
  RATE_PER_SQ_KM: 1000000,
  CROP_NAME: 20,
  COURSE_COST: 1000000,
  LOCATION_RADIUS: 999,
  SERVICE_NAME: 20,
  EMAIL: 100,
  AADHAR_LENGTH: 12,
  CROP_PRICE: 4,
  COMPELETED_AREA: 4,
  PAN_NUMBER: 10

}

const SETTELEMENT_STATUSES = {
  SETTELED: "settled",
  UNSETTLED: "unsettled"
}
const BHUMEET_TEAM_ROLES = {
  ADMIN: { NAME: "Admin", ALLOWED_API_BASE_URL: "/bhumeet_team/finance" },
  FINANCE: { NAME: "Finance", ALLOWED_API_BASE_URL: "/bhumeet_team/finance" },
  CUSTOMER_SUPPORT_ENGINEER: { NAME: "Customer support engineer", ALLOWED_API_BASE_URL: "/bhumeet_team/customer_success_engineer" },
  MARKETING: { NAME: "Marketing", ALLOWED_API_BASE_URL: "/bhumeet_team/marketing" },
  SALES: { NAME: "Sales", ALLOWED_API_BASE_URL: "/bhumeet_team/sales" },
  TELECALLER: { NAME: "Telecaller", ALLOWED_API_BASE_URL: "/bhumeet_team/Telecaller" },
  TELECALLER_SALES: { NAME: "Telecaller Sales", ALLOWED_API_BASE_URL: "/bhumeet_team/Telecaller_Sale" },
}

const PAYMENT_STATUSES = {
  INITIATED: "Initiated",
  EXPIRED: "Expired",
  PAID: "Paid",
  FAILED: "Failed",
  UNPAID: "Unpaid"
}

const PAYMENT_METHODS = {
  OFFLINE: "Offline",
  UPI: "UPI"
}

const DSP_INVOICES_TYPES = {
  DEBIT_FOR_BHUMEET: "DEBIT_FOR_BHUMEET",
  DEBIT_FOR_DSP: "DEBIT_FOR_DSP",
  INCENTIVE_TO_DSP: "INCENTIVE_TO_DSP"
}

const INECNTIVE_INVOICES_STATUS = {
  PAID: "Paid",
  UNPAID: "Unpaid",
}

const COUPON_TYPES = {
  SYSTEM: "SYSTEM",
  DSP: "DSP"
}

const CANCELLEDREQUESTNOTES = [
  "Given Service Location is Incorrect",
  "Restricted or Prohibited Area",
  "Appropriate Discount Not Applied",
  "Farmer is Not Reachable",
  "Requested date time not available",
  "Drone Crashed or Malfunctioned",
  "Adverse Weather Conditions",
  "Technical Issues in the Platform",
  "Wrongly Placed Order",
  "Farmer no longer needs spraying"
]


const ONHOLDREASONS = [
  `Farmer's Chemicals/Resources Not Ready`,
  `Adverse Weather Conditions`,
  `Drone Crashed or Malfunctioned`,
  `Technical Issues in the Platform`,
]

const RESCHEDULED_REASONS = [
  "Farmer Requested Date Change",
  "Farmer's Chemicals/Resources Not Ready",
  "Pilot Unavailable on Selected Date/Time",
  "Adverse Weather Conditions",
  "Drone Malfunctioned or Crashed",
  "Technical Issues in the Platform"
]

const BHUMEET_SUBSCRIPTIONS_LIMITS = {
  DRONES: "drones",
  LEADS: "leads",
  LOCATIONS: "locations",
  CROPS: "crops",
  PILOTS: "pilots",
}

const BHUMEET_SUBSCRIPTIONS_FEATURES = {
  DAILY_PILOT_TRACKING: 'Pilot Tracking',
  PILOT_CALENDER_VIEW: 'Pilot Calender View',
  PILOT_DAILY_TRACKING: 'Pilot Daily Tracking',
  PILOTS_MAP_VIEW: 'Map View For Pilots',
  PILOT_SMART_ROUTES_PLANNING: "Pilot Smart Route Planning",
  TEAMS: 'Teams',
}

const CANCEL_ORDER_REASONS = [
  "Given Service Location is Incorrect",
  "Restricted or Prohibited Area",
  "Farmer is Not Reachable",
  "Farmer no longer needs spraying",
  "Cancellation against invalid order"
]

export {
  CANCEL_ORDER_REASONS,
  BHUMEET_SUBSCRIPTIONS_LIMITS,
  BHUMEET_SUBSCRIPTIONS_FEATURES,
  SERVER_URLS,
  LIST_VIEW_TYPES,
  GLOBAL_STYLES,
  IDENTITY_CARD_TYPES,
  AEROMEGH_SERVICES,
  DRONE_CAPACITIES,
  DRONE_UIN,
  DRONE_TYPES,
  LIMITS,
  DRONE_NAMES,
  SERVICE_TYPES,
  STATUS,
  STATUS_MESSAGES,
  DISCOUNT_TYPES,
  PRICE_BY_TYPES,
  PRICE_BY,
  MAP_URLS,
  SETTELEMENT_STATUSES,
  BHUMEET_TEAM_ROLES,
  PAYMENT_STATUSES,
  REWARD_ORDERS_STATUSES,
  QUEUE_ORDER_STATUS,
  PAYMENT_METHODS,
  DSP_INVOICES_TYPES,
  INECNTIVE_INVOICES_STATUS,
  COUPON_TYPES,
  INDIAN_STATES,
  allIssueTypes,
  CANCELLEDREQUESTNOTES,
  ONHOLDREASONS,
  RESCHEDULED_REASONS,
  BES_INCENTIVE_STATUS
};
